import { gql } from "@apollo/client";

export const DELETE_TIME_SLOT = gql`
    mutation gqlDeleteTimeSlotById($nID: Int!) {
        code: gqlDeleteTimeSlotById(nID: $nID)
    }
`;

export const INSERT_TIME_SLOT = gql`
    mutation gqlInsertTimeSlot($timeSlot: TimeSlotInput) {
        code: gqlInsertTimeSlot(timeSlot: $timeSlot)
    }
`;

export const UPDATE_TIME_SLOT = gql`
    mutation gqlUpdateTimeSlot($nID: Int!, $timeSlot: TimeSlotInput) {
        code: gqlUpdateTimeSlot(nID: $nID, timeSlot: $timeSlot)
    }
`;